import { useState } from "react"
import cartpopup from "./cartpopup.module.css"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux";

export const CartPopup = (props) => {
    const cart = useSelector(state => state.cart)
    let subtotal = 0
    let items = 0
    for (let key of cart){
        if (key.quantity > 0){
        subtotal += key.quantity * key.price
        items += key.quantity
        }
  }

    return (
        <div>
   

        <div className={cartpopup.popupDiv} style={{display: props.show, position: "absolute"}}>
           <header>
           <h2>Added to Cart!</h2>
           <div onClick={props.closePopup} className={cartpopup.close}></div>
           </header>
           <img src={props.item.imageNobg}/>
            <hr />
       
        <footer>
            <p>Cart Total: £{subtotal} {`(${items} items)`}</p>
            <button onClick={() => window.location.href = props.item.paymentLink}>Proceed to Checkout</button>
            <Link to="/cart">
            <button>Go to Cart</button>
            </Link>
        </footer>
        </div>
        <div className={cartpopup.overlay} style={{display: props.show}} onClick={props.closePopup}></div>
        </div>
 )
}